const initialState = {
    screen: 'Campaigns',
    token: null,
    firebase_token: null,
    profile: null,
    active_job: null,
    finished_job: null,
    winning_bid: null,
    global_messages: [],
    job_messages: [],
    job: {
        job_type: '',
        image: '',
        make: '',
        model: '',
        year: '',
        color: '',
        address: {
            address: '',
            apartment: '',
            location_lng: '',
            location_lat: '',
            city: '',
            zip: '',
            state: '',
            additionalNote: '',
            name: '',
            firstname: '',
            lastname:''
        },        
        payment_method: 'credit_card',
        payment_data: null,
        numberOfLocks: '',
        orderDescription: '',
        residentialSwitch: '',
        ignDoorSwitch: '',
        lcSwitch: '',
        lcrSwitch: '',
        lockType: '',
        keyType: ''
    },
    account: [],
    phonenumber: '',
    cars_list: {},
    bids: {}
};

export default initialState;